<template>
  <div class="content-block icon-slide" :class="props.type">
    <div class="content-block__swiper__slide">
      <div
        v-if="item.portrait.length"
        class="content-block__swiper__slide__image"
      >
        <WidgetPicture
          :image="{
            portrait: item.portrait?.[0],
          }"
          :alt="item.portrait?.[0]?.title"
        />
      </div>
      <div class="content-block__swiper__slide__text">
        <div
          v-if="item?.sectionTitle"
          class="content-block__swiper__slide__title title-medium3 is-medium-bold"
          :style="{ color: item.coloreTitolo }"
        >
          <div v-html="item.sectionTitle" />
        </div>
        <div
          v-if="item?.text"
          class="content-block__swiper__slide__description text-medium5"
        >
          <div v-html="item.text" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: 'default',
  },
})
</script>

<script>
export default {
  name: 'IconSlide',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
